import { render } from "./CustomColumn.vue?vue&type=template&id=3a7246da&scoped=true"
import script from "./CustomColumn.vue?vue&type=script&lang=js"
export * from "./CustomColumn.vue?vue&type=script&lang=js"

import "./CustomColumn.vue?vue&type=style&index=0&id=3a7246da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7246da"],['__file',"src/components/h5/data/CustomColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a7246da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a7246da', __exports__)) {
    api.reload('3a7246da', __exports__)
  }
  
  module.hot.accept("./CustomColumn.vue?vue&type=template&id=3a7246da&scoped=true", () => {
    api.rerender('3a7246da', render)
  })

}


export default __exports__